"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lodash_1 = __importDefault(require("lodash"));
const strings_1 = require("../../../../constants/strings");
const StyledTextareaAutosize_1 = require("../../../../material-ui-theme/components/styled/StyledTextareaAutosize");
const zustandStore_1 = require("../../../../zustandStore");
const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === 'Tab') {
        event.target.blur();
    }
};
const useColumns = roleId => {
    const newCodingEntry = (0, zustandStore_1.useZustand)(state => state.codingEntry.newCodingEntry);
    const columns = [
        {
            field: 'entryId',
            flex: 3,
            headerName: strings_1.companySettingsCodingStrings.UNIQUE_IDENTIFIER_COLUMN,
            renderHeader: params => {
                return ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: params.colDef.headerName }));
            },
            renderCell: params => {
                return params.value.isDefaultEditableCell ? ((0, jsx_runtime_1.jsx)(StyledTextareaAutosize_1.StyledTextareaAutosize, { id: "uniqueIdentifier-textarea", "data-testid": "uniqueIdentifier-textarea", sx: { pl: 0, pr: 0 }, placeholder: params.value.placeholder ?? '', value: newCodingEntry.ID ?? '', readOnly: true })) : (params.value.text);
            },
            renderEditCell: params => {
                return ((0, jsx_runtime_1.jsx)(StyledTextareaAutosize_1.StyledTextareaAutosize, { id: "uniqueIdentifier-textarea", "data-testid": "uniqueIdentifier-textarea", autoFocus: true, placeholder: params.value.placeholder ?? '', defaultValue: params.value.text ?? '', onFocus: typeof params.value.onFocus === 'function' ? params.value.onFocus : lodash_1.default.noop, onChange: typeof params.value.onChange === 'function' ? params.value.onChange : lodash_1.default.noop, onBlur: typeof params.value.onBlur === 'function' ? params.value.onBlur : lodash_1.default.noop, onKeyDown: handleKeyDown }));
            },
            editable: roleId !== 'team_admin',
            sortable: false,
            filterable: false,
        },
        {
            field: 'entryPath',
            flex: 4,
            headerName: strings_1.companySettingsCodingStrings.CODING_ENTRY_COLUMN,
            renderHeader: params => ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", "ts-variant": 'tableHeaderTitle', children: params.colDef.headerName })),
            renderCell: params => {
                return params.value.isDefaultEditableCell ? ((0, jsx_runtime_1.jsx)(StyledTextareaAutosize_1.StyledTextareaAutosize, { id: "codingEntry-textarea", "data-testid": "codingEntry-textarea", sx: { pl: 0, pr: 0 }, placeholder: params.value.placeholder ?? '', value: newCodingEntry.path ?? '', readOnly: true })) : (params.value.text);
            },
            renderEditCell: params => {
                return ((0, jsx_runtime_1.jsx)(StyledTextareaAutosize_1.StyledTextareaAutosize, { id: "codingEntry-textarea", "data-testid": "codingEntry-textarea", autoFocus: true, placeholder: params.value.placeholder ?? '', defaultValue: params.value.text ?? '', onFocus: typeof params.value.onFocus === 'function' ? params.value.onFocus : lodash_1.default.noop, onChange: typeof params.value.onChange === 'function' ? params.value.onChange : lodash_1.default.noop, onBlur: typeof params.value.onBlur === 'function' ? params.value.onBlur : lodash_1.default.noop, onKeyDown: handleKeyDown }));
            },
            editable: roleId !== 'team_admin',
            sortable: false,
            filterable: false,
        },
        {
            flex: 1,
            field: 'rowActions',
            headerName: '',
            renderCell: params => params.value.isDefaultEditableCell ? ((0, jsx_runtime_1.jsx)(material_1.Button, { id: params.value.startIcon ? 'rowActions-button-with-icon' : 'rowActions-button', "data-testid": params.value.startIcon ? 'rowActions-button-with-icon' : 'rowActions-button', variant: "text", "ts-variant": params.value.tsVariant ?? '', startIcon: params.value.startIcon ?? '', onClick: typeof params.value.onClick === 'function' ? params.value.onClick : lodash_1.default.noop, title: params.value.text ?? '', style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '100%',
                    display: 'block',
                    textAlign: 'left',
                }, children: params.value.text ?? '' })) : ((0, jsx_runtime_1.jsx)(material_1.Switch, { sx: { display: 'flex', marginLeft: 'auto' }, color: "primary", name: "entryState", disabled: false, checked: params.value.checked, onChange: typeof params.value.onChange === 'function' ? params.value.onChange : lodash_1.default.noop })),
            sortable: false,
            filterable: false,
        },
    ];
    return columns;
};
exports.useColumns = useColumns;
